import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/parkSpacePage/v2', Object.assign({}, options, {
    params
  }));

export const getTreeChildrenCarParkNode = (params, options) =>
  request.get(
    '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2',
    Object.assign({}, options, {
      params
    })
  );

export const addParkSpaceNode = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/saveNode/v2', params, options);

export const getDetailById = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/detailById/v2', Object.assign({}, options, {
    params
  }));

export const update = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/submit/v2', params, options);

export const updateCarSpace = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/update/carspace/v2', params, options);

export const addPark = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/addPark/v2', params, options);

export const remove = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/remove/v2', qs.stringify(params), options);

export const syncParkPositions = (params, options) =>
  request.post('/api/v4ward/car/ParkSpace/syncPosition/v2', qs.stringify(params), options);
